import { render, staticRenderFns } from "./IdeaCollection.vue?vue&type=template&id=62cae68f&scoped=true"
import script from "./IdeaCollection.vue?vue&type=script&lang=js"
export * from "./IdeaCollection.vue?vue&type=script&lang=js"
import style0 from "./IdeaCollection.vue?vue&type=style&index=0&id=62cae68f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cae68f",
  null
  
)

export default component.exports